import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  Optional,
  Inject,
  ElementRef,
  ViewChild,
  OnChanges,
} from '@angular/core';
import { ActivityService } from '../../../core/services/activity.service';
import { FileService } from '../../../core/services/file.service';
import { ActivatedRoute } from '@angular/router';
import { HrPanelInterviewObj, HrPanelInterviewActivity } from '../../../shared/models/activity-dashboard-model';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ActivityDialogComponent } from 'src/app/modules/activities/activity-dialog/activity-dialog.component';
import { COMMA, ENTER } from '@angular/cdk/keycodes';
import { UntypedFormControl } from '@angular/forms';
import { Observable } from 'rxjs';
import { MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import { MatChipInputEvent } from '@angular/material/chips';
import { startWith, map } from 'rxjs/operators';

@Component({
  selector: 'app-activity-hrinterview',
  templateUrl: './activity-hrinterview.component.html',
  styleUrls: ['./activity-hrinterview.component.scss'],
  standalone: false,
})
export class ActivityHRInterviewComponent implements OnInit, OnChanges {
  public isCollapsed: boolean = false;
  //time
  public timeModifiedOn: string;
  @Input() checkHrPanelInterviewObj: HrPanelInterviewObj;
  @Input() candidateApplicationIds: number[];
  @Input() ifCoupled: boolean;
  @Output() refreshcandiates: EventEmitter<any> = new EventEmitter();
  @Output() singleformValid: EventEmitter<boolean> = new EventEmitter();

  referenceActivities: any[];
  inputVal: any;
  referenceId: any;
  empNo: any;
  hractivity: boolean = true;
  editactivity: boolean = false;
  remarks: any;
  refrenceindex: number;
  fileData: any;
  deletedFile: any;
  editId: any;
  companyHiringType: any; // = 1;
  userloggedin: any;
  loginUserName: any;
  toggleBtn: boolean = false;
  allowedTypes = '.doc,docx,.xls,xlsx,.pdf,.jpg,.jpeg,.msg,.png';
  multiple = 'multipleSelect';
  loader: boolean = false;
  single = 'single';

  placeHold = 'HR Employee Number*';
  visible: boolean = true;
  selectable: boolean = true;
  removable: boolean = true;
  addOnBlur: boolean = false;
  separatorKeysCodes = [ENTER, COMMA];
  empInputCtrl = new UntypedFormControl();
  inputCtrl = new UntypedFormControl();
  filteredEmp = [];
  empList = [];
  disableSend = true;
  hrEmpNo;
  savePanelData;
  @ViewChild('empInput') empInput: ElementRef;
  hideValidate: boolean = false;
  inValidEmpList: any = [];
  quitPanelistData = [];
  isMapFile = false;
  sendDisableHR = false;

  roleControl = new UntypedFormControl();
  roles: any[] = [];
  filteredRoles: Observable<any[]>;
  selectedJobSubLevel: string = '';
  onEdit: boolean;
  constructor(
    private hrInterviewService: ActivityService,
    private fileService: FileService,
    private route: ActivatedRoute,
    public dialogRef: MatDialogRef<ActivityDialogComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any,
  ) {
    if (data) {
      this.checkHrPanelInterviewObj = data.checkHrPanelInterviewObj;
      this.editactivity = data.editActivity;
      this.isCollapsed = data.editActivity;
    }
  }

  ngOnChanges() {
    this.referenceId = -1;
    this.empNo = '';
    this.remarks = '';
    this.hrEmpNo = '';
  }

  ngOnInit() {
    this.companyHiringType = localStorage.getItem('fresherCompHiringTypeId');
    this.isMapFile =
      this.companyHiringType == '1' &&
      (this.checkHrPanelInterviewObj.activityId == 500102 ||
        this.checkHrPanelInterviewObj.activityId == 500103 ||
        this.checkHrPanelInterviewObj.activityId == 500107)
        ? true
        : false;

    this.showMoreLess();
    this.userloggedin = JSON.parse(localStorage.getItem('loggedInUser'));
    console.log('loginuser---->', this.userloggedin);

    this.loginUserName = this.userloggedin.username;
    //  this.loginUserName="sandip"
    console.log(this.loginUserName);

    console.log(this.checkHrPanelInterviewObj);
    this.referenceId = -1;
    this.empNo = '';
    this.remarks = '';
    this.hrEmpNo = '';
    // this.editId = { objectId: this.checkHrPanelInterviewObj.applicationId, objectType: 'AP' };

    this.hractivity = this.checkHrPanelInterviewObj.isHrActivity;
    if (!this.hractivity) {
      this.placeHold = 'Panel Employee Number*';
    }
    console.log('inside hr component', this.hractivity);
    this.hrInterviewService.getReferenceActivity().subscribe((res) => {
      if (res.length > 0) {
        this.referenceActivities = res;
      }
    });
    this.hrInterviewService.getRoles().subscribe((res) => {
      if (res.length > 0) {
        this.roles = res;
        this.filteredRoles = this.roleControl.valueChanges.pipe(
          startWith(''),
          map((value) => this.filterRoles(value)),
        );
      }
      this.roleControl.valueChanges.subscribe((val) => {
        if (val && val.trim() !== '') {
          const selectedRole = this.roles.find((role) => role.roleCapDesc.toLowerCase() === val.toLowerCase());
          if (!selectedRole) {
            this.roleControl.setErrors({ invalidRole: true });
          } else {
            this.roleControl.setErrors(null);
            this.selectedJobSubLevel = selectedRole.jobSubLevel;
          }
        } else {
          this.selectedJobSubLevel = '';
          this.roleControl.setErrors({ required: true });
        }
      });
    });
    if (this.editactivity) {
      this.editId = {
        objectId: this.checkHrPanelInterviewObj.applicationId,
        objectType: 'AP',
        activityId: this.checkHrPanelInterviewObj.activityId,
      };
      this.showMoreLess();
      this.disableSend = false;
      this.getHrPanelActivity(this.checkHrPanelInterviewObj);
    }
    // this.showMoreLess();
    this.inputCtrl.valueChanges.subscribe((val) => {
      this.filteredEmp = [];
      if (typeof val === 'string' && val.length > 3) {
        // this.loader=true;
        // this.ngxLoader.start();
        this.hrInterviewService.getHrDetail(val).subscribe((response) => {
          if (response.empId != null) {
            this.filteredEmp.push(response);
          }
          // this.loader=false;
          // this.ngxLoader.stop();
          console.log('filteredlist--', this.filteredEmp);
        });
      }
    });
    if (this.companyHiringType != 1) {
      this.hideValidate = true;
    }
    if (Number(this.checkHrPanelInterviewObj.activityId) === 500107) {
      this.disableSend = false;
    }
    // if(this.companyHiringType == '1' && this.checkHrPanelInterviewObj.activityId == 500103){
    //   let body = {
    //     candidateId: Number(this.route.snapshot.paramMap.get('id')),
    //     activityId: this.checkHrPanelInterviewObj.activityId,
    //     applicationId :this.checkHrPanelInterviewObj.applicationId,
    //     processId: this.checkHrPanelInterviewObj.processId,
    //   }
    //   this.hrInterviewService.form2Check(body).subscribe( res => {
    //     console.log(res)
    //     if(res == 'Success'){
    //       this.sendDisableHR = false;
    //     }
    //     else this.sendDisableHR = true;
    //     if(res !== 'Success'){
    //       let data = {
    //         msg: res,
    //         isSuccess: false
    //       }
    //       this.hrInterviewService.openSnackBar(data, 'danger-snack');
    //     }
    //   })
    // }
  }
  filterRoles(value: string): any[] {
    const filterValue = value.toLowerCase();
    return this.roles.filter((role) => role.roleCapDesc.toLowerCase().includes(filterValue));
  }
  validateForm() {
    if (this.inputVal.length >= 1) {
      if (this.inValidEmpList.length > 0) {
        if (this.fileData != undefined && this.fileData.length > 0) {
          this.disableSend = false;
        } else {
          this.disableSend = true;
        }
      } else {
        this.disableSend = false;
      }
    } else {
      this.disableSend = Number(this.checkHrPanelInterviewObj.activityId) !== 500107;
    }
  }
  getSelectedEmp() {
    const empIdList1 = [];
    if (this.hractivity || this.companyHiringType != 1) {
      this.empList.forEach((item) => {
        empIdList1.push(item.empId);
      });
    } else {
      this.empList.forEach((item) => {
        empIdList1.push(item.empNo);
      });
    }
    return empIdList1.join(',');
  }
  add(events: MatChipInputEvent): void {
    const input1 = events.input;
    // Add our fruit
    // if ((value || '').trim()) {
    //   this.empList.push(value.trim());
    // }
    // Reset the input value
    if (input1) {
      input1.value = '';
    }
    this.empInputCtrl.setValue(null);
  }

  remove(empItem1: any): void {
    console.log(empItem1.empNo);
    const i = this.empList.indexOf(empItem1);
    if (i >= 0) {
      this.empList.splice(i, 1);
    }
    const j = this.inValidEmpList.indexOf(empItem1);
    if (j >= 0) {
      this.inValidEmpList.splice(j, 1);
    }
    this.inputVal = this.getSelectedEmp();
    this.validateForm();
  }

  selected(events: MatAutocompleteSelectedEvent): void {
    let dupCheck: boolean = true;
    this.empList.forEach((emp) => {
      if (emp['empName'] == events.option.value['empName']) {
        dupCheck = false;
        this.empInput.nativeElement.value = '';
        this.empInputCtrl.setValue(null);
      }
    });
    if (dupCheck) {
      this.empList.push(events.option.value);
      this.inputVal = this.getSelectedEmp();
      this.validateForm();
      this.empInput.nativeElement.value = '';
      this.empInputCtrl.setValue(null);
    }
  }

  showMoreLess() {
    this.isCollapsed = !this.isCollapsed;
  }

  testformValid(flag) {
    // console.log('single form working', flag);

    this.singleformValid.emit(flag);
  }
  validateId() {
    // this.empList.push({empName: this.hrEmpNo});
    // this.empList.push({empName: this.hrEmpNo});
    if (this.hrEmpNo) {
      this.loader = true;
      // this.ngxLoader.start();
      this.hrInterviewService
        .getSupportTeamMember(this.hrEmpNo, this.checkHrPanelInterviewObj.applicationId)
        .subscribe((res) => {
          this.savePanelData = res;
          if (this.savePanelData.isEligible == 'Y') {
            console.log(res);
            console.log(res.responseModel.empName);
            let dupCheck: boolean = true;
            this.empList.forEach((emp) => {
              if (emp['empName'] == res.responseModel.empName) {
                dupCheck = false;
                this.empInput.nativeElement.value = '';
                this.empInputCtrl.setValue(null);
              }
            });
            if (dupCheck) {
              this.empList.push(res.responseModel);
              this.loader = false;
              // this.ngxLoader.stop();
              this.inputVal = this.getSelectedEmp();
              //this.filteredEmp.push(response.responseModel);
              console.log(this.empList);
              console.log(this.inputVal);
              this.validateForm();
            }
            this.loader = false;
          } else {
            if (
              res.responseModel != null &&
              res.responseModel != undefined &&
              res.statusMessage != 'Referee cannot be a panelist'
            ) {
              this.empList.push(res.responseModel);
              this.inValidEmpList.push(res.responseModel);
              if (this.fileData != undefined && this.fileData.length > 0) {
                this.disableSend = false;
              } else {
                this.disableSend = true;
              }
            }
            const data1 = {
              msg: res.statusMessage,
              isSuccess: false,
            };
            this.hrInterviewService.openSnackBar(data1, 'danger-snack');
            this.loader = false;
          }
        });
      this.hrEmpNo = '';
    }
  }
  send() {
    const obj: HrPanelInterviewActivity = {
      applicationListId: this.candidateApplicationIds,
      activityId: this.checkHrPanelInterviewObj.activityId,
      processId: this.checkHrPanelInterviewObj.processId,
      remarks: this.remarks,
      seqId: -1,
      confirmationResults: this.referenceId,
      roles: this.roleControl.value,
      jobSubLevel: this.selectedJobSubLevel,
    };
    this.inputVal = this.getSelectedEmp();
    if (this.hractivity) {
      obj.addHr = this.inputVal;
      obj.addPanelist = null;
    } else {
      obj.addPanelist = this.inputVal? this.inputVal : this.userloggedin?.attributes?.EmpNo?.[0];
      obj.addHr = null;
    }
    console.log('object created', obj);
    if (this.editactivity) {
      obj.seqId = this.checkHrPanelInterviewObj.hrpanelactivity.seqId;
      // obj.createdOn=this.checkHrPanelInterviewObj.createdOn;
      // obj.createdBy=this.checkHrPanelInterviewObj.createdBy;
      console.log('hractivity-->', obj);

      this.editHrPanelInterviewActivity(obj);
    } else {
      this.saveHrPanelInterviewActivity(obj);
    }
    // this.refreshcandiates.emit("true");
  }

  surveyTechfeedbackController() {
    const data = {
      candidateId: Number(this.route.snapshot.paramMap.get('id')),
      applicationId: this.checkHrPanelInterviewObj.applicationId,
      activityTech: this.checkHrPanelInterviewObj.activityId,
      notes: this.remarks,
    };
    if (this.companyHiringType == '1' && this.checkHrPanelInterviewObj.activityId == 500102) {
      this.hrInterviewService.getSurveyTechFeedback(data).subscribe((res) => {
        console.log('response', res);
      });
    }
  }
  saveHrPanelInterviewActivity(obj: HrPanelInterviewActivity) {
    console.log('inside savehr method', obj);
    this.hrInterviewService.saveEditHrPanelInterview(obj).subscribe(
      (res) => {
        console.log('response', res);
        if (res.error && res.error.toLowerCase() === 'failure') {
          const data = {
            msg: res.message,
            isSuccess: false,
          };

          console.log(data);
          this.hrInterviewService.openSnackBar(data, 'danger-snack');
        } else {
          if (this.isMapFile) {
            this.fileService.saveAttachmentMultiple(
              this.checkHrPanelInterviewObj.applicationId,
              this.companyHiringType,
              this.fileData,
              this.deletedFile,
              this.checkHrPanelInterviewObj.activityId,
            );
          } else {
            this.saveAttachment(this.checkHrPanelInterviewObj.applicationId, this.companyHiringType);
          }

          const data2 = {
            msg: res.message,
            isSuccess: true,
          };

          this.hrInterviewService.openSnackBar(data2, 'success-snack');
          if (!this.ifCoupled) {
            this.refreshcandiates.emit('true');
          }
          this.surveyTechfeedbackController();
        }
      },
      (err2) => {
        console.log(err2);
        const datas = {
          msg: 'Some error Occurred',
          isSuccess: false,
        };

        this.hrInterviewService.openSnackBar(datas, 'danger-snack');
      },
    );
  }
  editHrPanelInterviewActivity(object: HrPanelInterviewActivity) {
    console.log('inside edit method');
    this.hrInterviewService.saveEditHrPanelInterview(object).subscribe(
      (res) => {
        console.log('response', res);
        if (res.error && res.error.toLowerCase() === 'failure') {
          const data = {
            msg: res.message,
            isSuccess: false,
          };
          console.log(data);
          this.hrInterviewService.openSnackBar(data, 'danger-snack');
        } else {
          if (this.isMapFile) {
            this.fileService.saveAttachmentMultiple(
              this.checkHrPanelInterviewObj.applicationId,
              this.companyHiringType,
              this.fileData,
              this.deletedFile,
              this.checkHrPanelInterviewObj.activityId,
            );
          } else {
            this.saveAttachment(this.checkHrPanelInterviewObj.applicationId, this.companyHiringType);
          }

          const data1 = {
            msg: 'Data Updated Successfully !!!',
            isSuccess: true,
          };

          this.hrInterviewService.openSnackBar(data1, 'success-snack');
        }
      },
      (_err) => {
        const data2 = {
          msg: 'Some error Occurred',
          isSuccess: false,
        };

        this.hrInterviewService.openSnackBar(data2, 'danger-snack');
      },
    );
    this.dialogRef.close();
  }
  getHrPanelActivity(HrPanelObj: HrPanelInterviewObj) {
    // obj.createdOn
    this.hrInterviewService
      .getHrPanelActivity(HrPanelObj.applicationId, HrPanelObj.activityId, HrPanelObj.createdOn)
      .subscribe((result1) => {
        console.log(result1);
        this.checkHrPanelInterviewObj.hrpanelactivity = result1[0];
        this.dataInitialization(result1[0]);
        if (result1[0].seqId > 0) {
          this.onEdit = true;
        }
      });
  }
  dataInitialization(hrpanelObj: HrPanelInterviewActivity) {
    if (hrpanelObj == null) {
      this.remarks = '';
    } else {
      if (this.companyHiringType == 1) {
        this.hrInterviewService.quitPanelist(this.checkHrPanelInterviewObj.applicationId).subscribe((quitPanel) => {
          console.log(quitPanel);
          this.quitPanelistData = quitPanel.filter((qp) => {
            return qp.activityPanelId == this.checkHrPanelInterviewObj.activityId;
          });
        });
      }

      console.log('hr[panelobj', hrpanelObj);
      this.remarks = hrpanelObj.remarks;
      this.roleControl.setValue(hrpanelObj.roles);
      this.selectedJobSubLevel = hrpanelObj.jobSubLevel;
      if (Number(this.checkHrPanelInterviewObj.activityId) === 500107) {
        this.referenceId = hrpanelObj.confirmationResults;
        return;
      }
      if (hrpanelObj.addHr !== null) {
        this.empList = [];
        const hrarray2 = hrpanelObj.addHr.split(',');
        console.log('hrarray', hrarray2);
        this.loader = true;
        // this.ngxLoader.start();
        hrarray2.forEach((item) => {
          this.hrInterviewService.getHrDetail(item).subscribe((respo) => {
            this.empList.push(respo);
            this.loader = false;
            // this.ngxLoader.stop();
          });
          this.empNo = hrpanelObj.addHr;
        });

        // this.hrInterviewService.getHrDetail(hrpanelObj.addHr).subscribe(resp=>{
        //   this.empList.push(resp);
        // })
        // this.empNo = hrpanelObj.addHr;
      } else {
        this.empList = [];
        const hrarray3 = hrpanelObj.addPanelist.split(',');
        // this.ngxLoader.start();
        this.loader = true;

        hrarray3.forEach((items) => {
          this.hrInterviewService.getHrDetail(items).subscribe((respo) => {
            const temp3 = respo;
            temp3['empNo'] = respo['empId'];
            this.empList.push(temp3);
            // this.ngxLoader.stop();
            this.loader = false;
          });
          this.empNo = hrpanelObj.addPanelist;
        });
      }
      console.log('edit emplist---', this.empList);
      this.referenceId = hrpanelObj.confirmationResults;
    }
  }

  isSendDisable(form) {
    if (form.invalid || (this.hractivity && this.roleControl.invalid)) {
      return true;
    } else if (Number(this.checkHrPanelInterviewObj.activityId) === 500107) {
      const resultSelected = this.referenceId != null && this.referenceId != -1;
      let hasAiBotTranscript = false;
      if (this.fileData && Array.isArray(this.fileData)) {
        hasAiBotTranscript = this.fileData.some((f) =>
          f.file?.name?.trim().toLowerCase().includes('ai bot interview transcript'),
        );
      }
      return !(resultSelected && hasAiBotTranscript);
    } else {
      if (!this.disableSend) {
        if (this.referenceId != -1 && this.empList.length > 0 && this.inValidEmpList.length < 1) {
          return false;
        } else {
          if (
            this.fileData != undefined &&
            this.fileData.length > 0 &&
            this.empList.length > 0 &&
            this.referenceId != -1
          ) {
            return false;
          } else {
            return true;
          }
        }
      } else {
        return true;
      }
    }
  }

  receiveFileOutput(filedata2) {
    console.log('inside recievefile format');
    this.fileData = filedata2['fileMerge1'];
    this.deletedFile = filedata2['deletedFile1'];
    if (this.fileData != undefined && this.fileData.length > 0) {
      this.disableSend = false;
    } else {
      if (this.inValidEmpList.length > 0) {
        this.disableSend = true;
      } else {
        this.disableSend = false;
      }
    }
    // console.log(this.fileData);
    // console.log(this.deletedFile);
  }

  saveAttachment(genericIds, companyHiringTypeId) {
    console.log('inside saveattachmnt suitability');
    if (this.deletedFile && this.deletedFile.length > 0) {
      this.deletedFile.forEach((file) => {
        this.fileService.deleteFile(file.fileID).subscribe(
          (_res) => {},
          (_err) => {
            const datanew = {
              msg: 'Some error Occurred',
              isSuccess: false,
            };
            this.hrInterviewService.openSnackBar(datanew, 'danger-snack');
          },
        );
      });
    }
    const activityId: any = this.checkHrPanelInterviewObj.activityId;
    const fds = new FormData();
    fds.append('objectId', genericIds);
    fds.append('objectType', 'AP');
    fds.append('attachmentId', '2');
    fds.append('companyHiringTypeId', companyHiringTypeId);
    fds.append('activityId', activityId);
    if (this.fileData && this.fileData.length > 0) {
      this.fileData.forEach((file) => {
        fds.append('file[' + file.name + ']', file);
      });
      console.log(fds);
      this.fileService.upload(fds).subscribe(
        (_res) => {},
        (_err) => {},
      );
    }
  }
}
